// extracted by mini-css-extract-plugin
var _1 = "TheEditors__DisplayFontHeading--Q4qwF";
export { _1 as "DisplayFontHeading" }
